import { hasConsent, onConsentChange } from "./consent.js";

/**
 * Matomo integration.
 *
 * `requireConsent` is pushed in site/snippets/head.php before the tracker
 * loads, so Matomo sends nothing at all until we say otherwise here.
 *
 * We use `setConsentGiven` rather than `rememberConsentGiven` on purpose:
 * `rememberConsentGiven` makes Matomo store its own `mtm_consent` cookie,
 * which would give us a second record of consent that can drift out of sync
 * with ours. `setConsentGiven` is session-scoped and has to be called on
 * every page load, which is exactly what we want — psw_consent stays the
 * single source of truth and Matomo is told fresh each time.
 */

const STATISTICS = "statistics";

// Guards against counting the same page twice if a visitor toggles statistics
// off and on again without navigating.
let hasTrackedThisPage = false;

function push(command) {
  window._paq = window._paq || [];
  window._paq.push(command);
}

function applyConsent() {
  if (hasConsent(STATISTICS)) {
    push(["setConsentGiven"]);

    if (!hasTrackedThisPage) {
      hasTrackedThisPage = true;
      push(["trackPageView"]);
      push(["enableLinkTracking"]);
    }
  } else {
    push(["forgetConsentGiven"]);
  }
}

export default function matomo() {
  applyConsent();
  onConsentChange(applyConsent);
}
